module.exports = __webpack_public_path__ + "b70c4fd94344b07a7d44972ca80d609d.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/pricing_single.svg
// module id = 1292
// module chunks = 73